import { Component } from '@angular/core';

import { TemplateService } from './template.service';

/**
 * This component displays the template loaded in TemplateService
 */
@Component({
    templateUrl: './template-popup.component.html',
    standalone: false,
})
export class TemplatePopupComponent {
    constructor(public templateService: TemplateService) {}
}
